<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-input :disabled="disabled" :placeholder="placeholder" size="mini" type="text" id="auditorselinp" v-model="calcAuditorName" :readonly="true">
          <el-button slot="append" class="search" icon="el-icon-search" size="mini" @click="searchAuditors" :disabled="disabled"> </el-button>
          <el-button slot="append" class="clear" icon="el-icon-circle-close" @click="selectAuditor({ auditorId: null })" size="mini" :disabled="disabled"> </el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-dialog :id="getUniqueDialogId()" title="Select Auditor" :visible.sync="showSearch" width="60%" :append-to-body="true" @opened="handleOpen">
      <el-popover trigger="click" placement="right" v-model="addAuditorPopOverVisible">
        <el-form size="mini" ref="auditorform" label-position="top" label-width="120px" :rules="auditorRules" :model="auditorForm">
          <el-form-item size="mini" label="Add Auditor" prop="addAuditor" id="addAuditorInput">
            <el-input :disabled="disabled" size="mini" :maxlength="50" type="text" id="addAuditor" v-model="auditorForm.addAuditor"> </el-input>
          </el-form-item>
        </el-form>
        <br />
        <el-button-group style="margin: 0px 0px 0px 10px;">
          <el-button
            class="hiaButton"
            type="text"
            plain
            round
            @click="
              addAuditorPopOverVisible = false
              auditorForm.addAuditor = ''
            "
            size="mini"
            >Cancel</el-button
          >
          <el-button class="hiaButton" plain round @click="addAuditor()" size="mini">Confirm</el-button>
        </el-button-group>
        <div slot="reference" class="addButton">
          <el-button class="hiaButton" plain round size="mini" icon="el-icon-plus" title="Add Auditor">Add New Auditor </el-button>
        </div>
      </el-popover>
      <el-form size="mini" label-position="left" label-width="150px" v-loading="auditorsLoading" element-loading-spinner="atom-audit-loader">
        <v-server-table class="hiaTable" v-loading="tableLoading" @loading="tableLoading = true" element-loading-spinner="atom-audit-loader" @loaded="loaded" name="auditorListGrid" ref="auditorListGrid" id="auditorListGrid" :columns="auditorColumns" :options="auditoroptions">
          <template slot="name" slot-scope="props">
            <el-button :disabled="props.row.inactive || disabled" tabindex="0" class="select-button" type="text" @click="selectAuditor(props.row)" size="mini">
              {{ props.row.name + (props.row.inactive ? ' (Inactive)' : '') }}
            </el-button>
          </template>
          <template slot="h__email">
            Email
            <el-tooltip effect="dark" content="Linked user email address, users can be linked to auditors via the User Admin menu." placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </template>
          <template slot="email" slot-scope="props">
            {{ props.row.users && props.row.users.length > 0 ? props.row.users.map(x => x.email).join(', ') : null }}
          </template>
        </v-server-table>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'auditorSelector',
    props: ['value', 'clientauditor', 'disabled', 'placeholder'],
    data() {
      return {
        activeName: 'client',
        addAuditorPopOverVisible: false,
        auditorForm: {
          addAuditor: ''
        },
        auditorRules: {
          addAuditor: [{ required: true, message: 'Please Set Auditor' }]
        },
        auditorsLoading: false,
        showSearch: false,
        tableLoading: false,
        auditorColumns: ['name', 'email'],
        auditoroptions: {
          requestFunction: async data => {
            try {
              const payload = {
                data: data
              }
              return await this.LOAD_AUDITOR_PAGINATED(payload)
            } catch (err) {
              console.log(err)
            }
          },
          filterByColumn: true,
          headings: {
            email: 'User Email'
          },
          perPage: 15,
          texts: {
            filter: '',
            filterBy: '...'
          },
          highlightMatches: true,
          sortIcon: { is: 'none' }
        }
      }
    },
    methods: {
      ...mapActions('managedLists/auditors/', ['LOAD_AUDITOR_PAGINATED', 'POST_AUDITOR']),
      getUniqueDialogId() {
        return `auditorSelectorDialog${this._uid}`
      },
      loaded() {
        this.tableLoading = false
        const dialog = document.getElementById(this.getUniqueDialogId())
        const tds = dialog.getElementsByTagName('td')
        for (let i = 0; i < tds.length; i++) {
          tds[i].tabIndex = -1
        }
      },
      handleOpen() {
        const dialogId = this.getUniqueDialogId()
        const input = document.querySelector(`#${dialogId} #auditorListGrid input[name="vf__name"]`)
        if (input) {
          input.focus()
        }
      },
      searchAuditors() {
        this.showSearch = true
      },
      selectAuditor(row) {
        this.$emit('selected', row)
        this.$emit('input', row.auditorId)
        this.showSearch = false
      },
      addAuditor() {
        this.$refs.auditorform.validate(async valid => {
          if (valid) {
            try {
              const payload = {
                clientauditor: {
                  name: this.auditorForm.addAuditor
                }
              }
              const response = await this.POST_AUDITOR(payload)
              this.addAuditorPopOverVisible = false
              this.$refs.auditorform.resetFields()
              this.selectAuditor(response)
            } catch (err) {}
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      initialize() {}
    },
    computed: {
      calcAuditorName: {
        get: function() {
          if (this.clientauditor) {
            return this.clientauditor.name
          }
          return null
        }
      }
    },
    created: function() {
      this.initialize()
    }
  }
</script>

<style scoped>
  .clientauditor-selector-buttons >>> .el-button.el-button--default.el-button--mini {
    padding: 4px 9px;
    margin-top: -1px;
  }

  .auditorButtons {
    padding: 1px 0px 0px 5px;
  }

  .addButton {
    width: 115px;
    margin: 0px 0px 10px 0px;
  }

  >>> .select-button {
    border: 2px solid rgba(255, 255, 255, 0);
    padding: 7px 5px 7px 5px;
    width: 100%;
    text-align: left;
  }

  >>> .select-button:focus {
    border: 2px solid #409eff;
    border-radius: 0px;
  }
</style>
